// extracted by mini-css-extract-plugin
export default {"root":"ListCardIcon_root__HwwSx","green":"ListCardIcon_green__IplhC","blue":"ListCardIcon_blue__tAURT","red":"ListCardIcon_red__iIR+n"};